<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="所属项目：" prop="projectId">
          <el-select
            size="mini"
            v-model="projectObj"
            filterable
            placeholder="请选择所属项目"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchProjectList"
            @visible-change="searchProjectList('')"
            @change="chooseProject"
            value-key="id"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.projectName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯：" prop="liftId" class="mr0">
          <el-select
            size="mini"
            v-model="form.liftId"
            filterable
            placeholder="请选择电梯"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchLiftList"
            @visible-change="searchLiftList('')"
          >
            <el-option
              v-for="item in liftList"
              :key="item.liftId"
              :label="item.liftLocation"
              :value="item.liftId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型：" prop="feeType">
          <el-select
            size="mini"
            v-model="form.feeType"
            placeholder="请选择费用类型"
          >
            <el-option
              v-for="item in wxffylxDicts"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额：" prop="amount" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.amount"
            v-number-only:20="2"
            placeholder="请输入金额"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="配件名称：" class="input-with-col2 mr0">
          <el-row :gutter="4" v-for="(item, index) in partList" :key="index">
            <el-col :span="10">
              <el-input
                placeholder="请输入名称"
                size="mini"
                width="100%"
                v-model="item.partName"
                @change="changePartName"
              ></el-input>
            </el-col>
            <el-col :span="10" class="upImgbox">
              <el-button class="button" size="mini" type="primary">{{
                item.partName ? item.partName : "上传图片"
              }}</el-button>
              <input
                class="input"
                type="file"
                @change="(e) => handleFileChange(e, index)"
              />
            </el-col>
            <el-col :span="4">
              <el-button type="text" size="mini" @click="delPart(index)"
                >删除</el-button
              >
              <!-- <el-button type="text" size="mini" @click="handleLookLarge(index)">查看</el-button> -->
              <el-button
                type="text"
                size="mini"
                @click="addPart"
                v-if="index == partList.length - 1"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="收款状态：" prop="paymentStatus">
          <el-select size="mini" v-model="form.paymentStatus">
            <el-option
              v-for="item in wxfsfztDicts"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款金额：" prop="receivableAmount" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.receivableAmount"
            v-number-only:20="2"
            placeholder="请输入收款金额"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="收款日期：" prop="receivableTime">
          <el-date-picker
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            placeholder="请选择收款日期"
            v-model.trim="form.receivableTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="收款人：" prop="receiverId" class="mr0">
          <el-select
            size="mini"
            v-model="form.receiverId"
            filterable
            placeholder="请选择收款人"
            clearable
            reserve-keyword
            :remote="true"
            collapse-tags
            :remote-method="searchUserList"
            @visible-change="searchUserList('')"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getProjectSimpleList, getLiftSimpleList } from "@/api/MaintenancePlan";
import { mapState } from "vuex";
import { getUserSimpleList } from "@/api/MaintenancePlan";
import { addRepair } from "@/api/MaintenanceFeeConfirmation";
import { uploadFile } from "@/api/Sys";
export default {
  data() {
    return {
      form: {
        liftId: null,
        projectId: null,
        projectName: "",
        receivableAmount: null,
        receivableTime: "",
        receivableWay: "",
        receiverId: "",
        paymentStatus: "",
        feeType: null,
        amount: null,
        partList: [
          {
            partName: "",
            partImage: "",
          },
        ],
      },
      partList: [{}],
      projectObj: null,
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择所属项目",
            trigger: "change",
          },
        ],
        liftId: [
          {
            required: true,
            message: "请选择电梯",
            trigger: "change",
          },
        ],
        feeType: [
          {
            required: true,
            message: "请选择费用类型",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
        paymentStatus: [
          {
            required: true,
            message: "请选择收款状态",
            trigger: "change",
          },
        ],
        receivableAmount: [
          {
            required: true,
            message: "请输入收款金额",
            trigger: "blur",
          },
        ],
        receivableTime: [
          {
            required: true,
            message: "请选择收款日期",
            trigger: "change",
          },
        ],
        receiverId: [
          {
            required: true,
            message: "请选择收款人",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      projectList: [],
      liftList: [],
      userList: [],
    };
  },
  computed: {
    ...mapState("common/dictionary", ["wxffylxDicts", "wxfsfztDicts"]),
  },
  created() {},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const params = { ...this.form };
          params.receiverId = params.receiverId * 1;
          params.projectId = params.projectId * 1;
          params.feeType = params.feeType * 1;
          params.liftId = params.liftId * 1;
          params.amount = params.amount * 1;
          params.receivableWay = params.receivableWay * 1;
          params.receivableAmount = params.receivableAmount * 1;
          params.paymentStatus = params.paymentStatus * 1;
          params.partList = this.partList;
          const res = await addRepair(params);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchLiftList(keyword) {
      if (!this.form.projectId) {
        return;
      }
      const res = await getLiftSimpleList({
        keyword: keyword,
        size: 100,
        projectId: this.form.projectId,
      });
      if (res.code === 200) {
        this.liftList = res.data;
      }
    },
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    chooseProject(val) {
      if (val && val.id) {
        this.form.projectId = val.id;
        this.form.projectName = val.projectName;
      } else {
        this.form.projectId = "";
        this.form.projectName = "";
      }
    },
    addPart() {
      this.partList.push({});
    },
    delPart(index) {
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.partList.splice(index, 1);
          if (!this.partList.length) {
            this.partList.push({});
          }
        })
        .catch((e) => {
          console.log("cancel");
        });
    },
    async handleFileChange(e, index) {
      const file = e.target.files[0];
      if (file.size > 10 * 1024 * 1024) {
        e.target.value = "";
        this.$message.warning("图片大小必须小于10M");
        return;
      }

      let formData = new FormData();
      formData.append("file", file);
      const res = await uploadFile(formData);
      if (res) {
        this.$set(this.partList[index], "partImage", res.reourceAddress);
        this.$set(this.partList[index], "partName", file.name);
      } else {
        this.$set(this.partList[index], "partImage", null);
        e.target.value = "";
      }
    },
    changePartName(val) {
      console.log(this.partList);
    },
  },
};
</script>
<style lang="scss">
.upImgbox {
  position: relative;
  .input {
    position: absolute;
    width: 100%;
    cursor: pointer;
    height: 28px;
    left: 2px;
    top: 2px;
    // right: 2px;
    // bottom: 0;
    opacity: 0;
  }
  .button {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceFeeConfirmation/components/addDialog.vue